import React from "react";
import saveAs from "../main/saveas";
import { CaptureOptions } from "../options";

const useScreenshot = () => {
  // capture Handler as Simple as That
  const captureHandler = React.useCallback(
    async (options?: CaptureOptions): Promise<void> => await saveAs(options),
    []
  );

  /**
   * A basic handler to download image it's so simple and effective
   * @param options - ScreenshotOptions for customize your output image
   */
  const captureImage = React.useMemo(() => captureHandler, [captureHandler]);

  return captureImage;
};

export default useScreenshot;
